import tagsNav from './Main.vue';

export default tagsNav;
